import { render, staticRenderFns } from "./manageJobsAndCustomers.vue?vue&type=template&id=f2528da0&scoped=true&"
import script from "./manageJobsAndCustomers.vue?vue&type=script&lang=js&"
export * from "./manageJobsAndCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2528da0",
  null
  
)

export default component.exports